// extracted by mini-css-extract-plugin
export default {"wrapper":"OrangeInfoBanner_wrapper__pkV51","vehicleRemindersPageInfo":"OrangeInfoBanner_vehicleRemindersPageInfo__G+Ak1","title":"OrangeInfoBanner_title__3dkPh"};